<template>
    <span v-if="statusText">
        <Badge
            :status="statusColor"
            class="'big no-text mr-3"
            :class="statusClass"
        />
        {{ statusText }}</span
    >
</template>

<script>
import Integrations from "@/js/lookups/integrations";

export default {
    props: {
        integration: Object,
        format: {
            type: String,
            default: "long",
        },
    },
    computed: {
        statusText() {
            let translation = this.$t(
                "partials.integrations.integrations.statuses." +
                    this.integration.status_id
            );
            if (this.format === "short") {
                return translation;
            }
            return this.$t("partials.integrations.integrations.status", {
                status: translation,
            });
        },
        statusColor() {
            let Helper = new Integrations();
            switch (this.integration.status_id) {
                case Helper.INTEGRATION_STATUSES.INACTIVE:
                case Helper.INTEGRATION_STATUSES.PENDING:
                case Helper.INTEGRATION_STATUSES.NOT_INTEGRATED: // PSEUDO
                case Helper.INTEGRATION_STATUSES.REFRESH_FAILED:
                    return "warning";
                case Helper.INTEGRATION_STATUSES.ACTIVE:
                    return "success";
                case Helper.INTEGRATION_STATUSES.DELETING:
                case Helper.INTEGRATION_STATUSES.PURGING:
                    return "error";
                default:
                    return "";
            }
        },
        statusClass() {
            let Helper = new Integrations();
            switch (this.integration.status_id) {
                case Helper.INTEGRATION_STATUSES.ACTIVE:
                    return "badge-pulsating";
                default:
                    return "";
            }
        },
    },
};
</script>
